import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
const Logout = () => {
  const navigate = useNavigate()
  useEffect(() => {
    // Clear ALL data for complete cleanup
    localStorage.clear();
    sessionStorage.clear();

    // await new Promise(resolve => setTimeout(resolve, 1000))
    navigate('/login')
  }, [])
  return (
    <div>
      <h1>Logout...</h1>
    </div>
  )
}

export default Logout